import history from 'appHistory';

export const redirectToPage = (path) => () => {
  history.push(`/${path}`);
};
